module.exports = __webpack_public_path__ + "static/img/healthP3.55bfe0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthP3.jpg
// module id = axzD
// module chunks = 1